import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import { FILE_PATH } from "./config/environment";
import MandatoryPage from "./components/MandatoryPage.vue";
import AlertBox from "./components/AlertBox.vue";
import CardLoader from "./components/CardLoader.vue";

axios.defaults.baseURL = FILE_PATH;

const app = createApp(App).use(router);
app.use(store);
app.use(router);
app.component("MandatoryPage", MandatoryPage);
app.component("AlertBox", AlertBox);
app.component("CardLoader", CardLoader);
app.mount("#app");

// createApp(App).use(router).mount('#app')
